import React from 'react'
import styled from 'styled-components'

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.md};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.background};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

const Icon = styled.div`
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.radii.sm};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
`

const Description = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export function MiniIconCard({ icon, title, description, onClick, ...props }) {
  return (
    <Card onClick={onClick} {...props}>
      <Icon>{icon}</Icon>
      <Content>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </Content>
    </Card>
  )
}
